/* istanbul ignore file */

import { GlobalStyles } from '@mui/material';

const getFontFaces = (properties: { baseUrl?: string }) => {
    const baseUrl = properties.baseUrl ? `${properties.baseUrl}/` : '/';
    const location = `${baseUrl}fonts`;

    return [
        {
            '@font-face': {
                fontWeight: 'bold',
                fontFamily: 'thegymgroupsans-Bold',
                fontStyle: 'normal',
                fontDisplay: 'swap',
                unicodeRange: 'U+000-5FF',
                src: `local('thegymgroupsans-Bold'), url('${location}/thegymgroupsans-Bold.woff2') format('woff2'), url('${location}/thegymgroupsans-Bold.woff') format('woff');`,
            },
        },
        {
            '@font-face': {
                fontWeight: '500',
                fontFamily: 'thegymgroupsans-BoldItalic',
                fontStyle: 'italic',
                fontDisplay: 'swap',
                unicodeRange: 'U+000-5FF',
                src: `local('thegymgroupsans-BoldItalic'), url('${location}/thegymgroupsans-BoldItalic.woff2') format('woff2'), url('${location}/thegymgroupsans-BoldItalic.woff') format('woff');`,
            },
        },
        {
            '@font-face': {
                fontWeight: '500',
                fontFamily: 'thegymgroupsans-Headline',
                fontStyle: 'normal',
                fontDisplay: 'swap',
                unicodeRange: 'U+000-5FF',
                src: `local('thegymgroupsans-Headline'), url('${location}/thegymgroupsans-Headline.woff2') format('woff2'), url('${location}/thegymgroupsans-Headline.woff') format('woff');`,
            },
        },
        {
            '@font-face': {
                fontFamily: 'ABCGravity',
                fontWeight: '900',
                fontStyle: 'normal',
                fontDisplay: 'swap',
                unicodeRange: 'U+000-5FF',
                src: `local('ABCGravity-Compressed'), url('${location}/ABCGravity-Compressed.woff2') format('woff2'), url('${location}/ABCGravity-Compressed.woff') format('woff');`,
            },
        },
        {
            '@font-face': {
                fontFamily: 'TGGSans',
                fontWeight: '400',
                fontStyle: 'normal',
                unicodeRange: 'U+000-5FF',
                src: `local('TGGSans-Regular'), url('${location}/TGGSans-Regular.woff2') format('woff2'), url('${location}/TGGSans-Regular.woff') format('woff');`,
            },
        },
        {
            '@font-face': {
                fontFamily: 'TGGSans',
                fontWeight: '700',
                fontStyle: 'normal',
                fontDisplay: 'swap',
                unicodeRange: 'U+000-5FF',
                src: `local('TGGSans-Bold'), url('${location}/TGGSans-Bold.woff2') format('woff2'), url('${location}/TGGSans-Bold.woff') format('woff');`,
            },
        },
        {
            '@font-face': {
                fontFamily: 'TGGSans',
                fontWeight: '500',
                fontStyle: 'normal',
                fontDisplay: 'swap',
                unicodeRange: 'U+000-5FF',
                src: `local('TGGSans-Medium'), url('${location}/TGGSans-Medium.woff2') format('woff2'), url('${location}/TGGSans-Medium.woff') format('woff');`,
            },
        },
    ];
};

// eslint-disable-next-line unicorn/prevent-abbreviations
export const Fonts: React.FC<{ baseUrl?: string }> = props => {
    const fontFaces = getFontFaces(props);

    return <GlobalStyles styles={{ fontFaces }} />;
};
